import Entities from "./shared/Entities";

export default class Listing {
  constructor() {
    this.entities = new Entities(
      "Listing",
      "[data-listing-container]",
      Listing.initSingle,
      Listing.destroySingle
    );
  }

  static initSingle(containerEl) {
  const button = containerEl.querySelector("[data-listing-button]");
  const tabButtons = containerEl.querySelectorAll("[data-listing-tab-button]");
  const elements = containerEl.querySelectorAll("[data-listing-element]");
  const elementsToShow = 12;

  let activeTerm = null;

  function updateElementsVisibility() {
    const activeElements = Array.from(elements).filter(el => {
      if (!activeTerm) return true;

      const terms = el.getAttribute("data-terms")?.split(" ") || [];
      return terms.includes(activeTerm);
    });

    elements.forEach(el => el.removeAttribute("data-active"));

    activeElements.forEach((el, index) => {
      el.setAttribute("data-active", "");

      if (index < elementsToShow) {
        el.setAttribute("data-show", "");
      } else {
        el.removeAttribute("data-show");
      }
    });

    if (activeElements.length > elementsToShow) {
      button.setAttribute("data-active", "");
    } else {
      button.removeAttribute("data-active");
    }
  }

  tabButtons.forEach(tab => {
    tab.addEventListener("click", () => {
      activeTerm = tab.getAttribute("data-term");

      tabButtons.forEach(t => t.removeAttribute("data-active"));
      tab.setAttribute("data-active", "");

      updateElementsVisibility();
    });
  });

  button.addEventListener("click", () => {
    const activeElements = Array.from(elements).filter(el => el.hasAttribute("data-active"));
    activeElements.forEach(el => el.setAttribute("data-show", ""));
    button.removeAttribute("data-active");
  });

  updateElementsVisibility();
}

  static destroySingle({ entityObj }) {
    entityObj?.destroy();
  }
}
